(() => {
  if (window.ifTikTokPackageLinkValidation) return;
  window.ifTikTokPackageLinkValidation = true;
  const selector = 'input[data-tiktok-package-link]';
  function validate(input) {
    const value = input.value.trim();
    let valid = false;
    try {
      const url = new URL(value);
      valid = url.protocol === 'https:' && !url.username && !url.password && !url.port &&
        ['tiktok.com', 'www.tiktok.com'].includes(url.hostname) &&
        /^\/@[A-Za-z0-9._]+\/video\/[0-9]+\/?$/.test(url.pathname);
    } catch {}
    input.setCustomValidity(valid ? '' : input.dataset.linkError);
    return valid;
  }
  document.addEventListener('input', event => {
    if (event.target.matches?.(selector)) validate(event.target);
  });
  document.addEventListener('submit', event => {
    const input = event.target.querySelector?.(selector);
    if (input && !validate(input)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.reportValidity();
    }
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest?.('button[type="submit"]');
    const input = button?.form?.querySelector(selector);
    if (input && !validate(input)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.reportValidity();
    }
  }, true);
})();
